import { render, staticRenderFns } from "./report-assignment-form.vue?vue&type=template&id=6d972c20"
import script from "./report-assignment-form.vue?vue&type=script&lang=js"
export * from "./report-assignment-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports